import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  event_name: 'vto',
  event_category: 'vto',
  event_label: 'event',
  vendor: 'youcam',
  event_action: null
};

function trackVTOActions(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('VTOActionsTracking', trackVTOActions);
